import { NewProjectStepper } from "@/components/forms/contract/NewProjectStepper"
import { ProjectScoped } from "@/components/forms/contract/nieuw-contract/ProjectStepperDefinition"
import ScreenWrapper from "@/components/ScreenWrapper"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/contracten/nieuw-contract/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <ScreenWrapper showManagementMenu>
      <ProjectScoped>
        <NewProjectStepper />
      </ProjectScoped>
    </ScreenWrapper>
  )
}
